const adminToolsTitle = 'Administration Tools';

export default {
  home: {
    location: '/apps/home',
    title: 'Home',
  },
  crm: {
    location: '/apps/agent',
    title: 'CRM',
  },
  analytics: {
    location: '/apps/analytics',
    title: 'Analytics',
  },
  voice: {
    location: '/NextOSPortal/ncp/admin/dashboard',
    title: 'Voice',
  },
  surveys: {
    location: '/apps/surveys/editor',
    title: 'Surveys',
  },
  email: {
    location: '/apps/nextmail',
    title: 'Email Marketing',
  },
  calendar: {
    location: '/apps/calendar',
    title: 'Calendar',
  },
  wiki: {
    location: 'https://wiki.unitedweb.com',
    title: 'Wiki',
  },
  helpCenter: {
    location: '#',
    title: 'Help Center',
  },
  nextOS: {
    location: '#',
    title: 'Next OS',
  },
  social: {
    location: '#',
    title: 'Social',
  },
  tasks: {
    location: '#',
    title: 'Tasks',
  },
  // ADMINISTRATION TOOLS:
  platformAdmin: {
    location: '/apps/home/#/admin',
    title: adminToolsTitle,
  },
  crmAdmin: {
    location: '/apps/admin',
    title: adminToolsTitle,
  },
  builder: {
    location: '/apps/builder',
    title: adminToolsTitle,
  },
  dataMigration: {
    location: '/apps/data-migration',
    title: adminToolsTitle,
  },
  rulesEngine: {
    location: '/apps/rules-engine',
    title: adminToolsTitle,
  },
  chat: {
    location: '/apps/chat',
    title: adminToolsTitle,
  },
  integrations: {
    location: '/apps/integrations/',
    title: adminToolsTitle,
  },
};
